import { StoryblokImage } from '@/components/customFields/StoryblokImage';
import classes from '@/components/magazineTrendCard/MagazineTrendCard.module.scss';
import { getFormattedDate } from '@/helper/dates';
import { linkToString } from '@/helper/urls';
import ArrowForwardIcon from '@/public/icons/pfeil-rechts-bolder.svg';
import type { AssetStoryblok, MultilinkStoryblok } from '@/types/component-types-sb';
import { ColumnWidth } from '@/types/layoutTypes';
import classNames from 'classnames';
import Link from 'next/link';

type MagazineTrendCardProps = {
  date?: string;
  link?: MultilinkStoryblok | string;
  image?: AssetStoryblok;
  title?: string;
  className?: string;
};

const MagazineTrendCard: React.FC<MagazineTrendCardProps> = ({ date, link, image, title, className }) => {
  return (
    <article className={classNames([classes.MagazineTrendCard, className])} aria-label={title}>
      <Link prefetch={false} href={linkToString(link)} className={classes.MagazineTrendCardLink}>
        {image && (
          <StoryblokImage
            className={classes.MagazineTrendCardImage}
            image={image}
            width={{
              columnsMobile: ColumnWidth.HALF,
              columnsTablet: ColumnWidth.ONE_QUARTER,
              columnsDesktop: ColumnWidth.ONE_SIXTH,
            }}
          />
        )}
        <div className={classes.MagazineTrendCardContent}>
          <div className={classes.MagazineTrendCardText}>
            {date && (
              <div className={classNames(classes.MagazineTrendCardDate, 'font-copy-small')}>
                {getFormattedDate(date)}
              </div>
            )}
            <div className={classNames(classes.MagazineTrendCardTitle, 'font-display-7')} title={title}>
              {title}
            </div>
          </div>

          <ArrowForwardIcon className={classes.MagazineTrendCardIcon} aria-hidden="true" />
        </div>
      </Link>
    </article>
  );
};
export default MagazineTrendCard;
